import { render, staticRenderFns } from "./white-list.vue?vue&type=template&id=a5d25c62"
import script from "./white-list.vue?vue&type=script&lang=js"
export * from "./white-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports